import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Autoplay, Scrollbar, Grid } from 'swiper/modules';
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay, Scrollbar, Grid]);

const equipmentSlider = new Swiper('.equipment-slider', {
  slidesPerView: 1,
  spaceBetween: 30,
  grid: {
    rows: 2,
    fill: 'row',
  },
  breakpoints: {
    1250: {
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: 'row',
      },
    }
  },
  pagination: {
    el: ".equip-pagination",
  },
  navigation: {
    nextEl: ".equip-swiper-button-next",
    prevEl: ".equip-swiper-button-prev",
  },
});
